<dashboardnav>
  <cradua-document-category [documentcategorys]="documentcategorys$ | async"
    (documentcategory)="onSubmitDocumentCategory($event)"
    (deleteDocumentCategoryEvent)="onDeleteDocumentCategory($event)"
    *ngIf="(isLoadingDocumentCategory$ | async ) === false">
  </cradua-document-category>

  <mrsoftapps-epims-reference-spinner *ngIf="(isLoadingDocumentCategory$ | async) === true">
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
